"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactMotion = require("react-motion");

var _styles = require("@qc-modules/styles");

var _inputLabel = _interopRequireDefault(require("../input-label"));

var _icons = require("../icons");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _excluded = ["label", "height", "checked", "fill", "onChange", "value"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Label = (0, _styledComponents["default"])(_inputLabel["default"]).withConfig({
  displayName: "checkbox__Label",
  componentId: "sc-u4j1ey-0"
})(["display:inline-flex;align-items:center;"]);
var Root = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "checkbox__Root",
  componentId: "sc-u4j1ey-1"
})(["align-items:center;border:1px solid ", ";border-radius:2px;display:inline-flex;align-items:center;justify-content:center;height:", "px;position:relative;width:", "px;input[type=\"checkbox\"]{display:none;}"], function (props) {
  return (0, _styles.colors)("border", props);
}, function (props) {
  return props.height;
}, function (props) {
  return props.height;
});
var Check = (0, _styledComponents["default"])(_icons.CheckmarkIcon).withConfig({
  displayName: "checkbox__Check",
  componentId: "sc-u4j1ey-2"
})(["width:90%;height:90%;position:absolute;"]);

var getVisibilityState = function getVisibilityState(checked) {
  return checked ? 1 : 0;
};

var getIconStyle = function getIconStyle(state) {
  return {
    opacity: state,
    transform: "scale(" + (state * 0.2 + 0.8) + ")"
  };
};

var propTypes = {
  /** Checkbox label content */
  checked: _propTypes.bool,

  /** Checkbox height in px */
  fill: _propTypes.string,

  /** Checbox active state */
  height: _propTypes.number,

  /** Checkbox icon fill color */
  label: _propTypes.node,

  /** Checkbox input onChange handler function */
  onChange: _propTypes.func,

  /** Checkbox input value, defaults to label value if present */
  value: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
};
/**
 * Generic checkbox component for representing boolean form inputs. Outer
 * container is an [InputLabel]() component and accepts all related props.
 * Active state displays CheckmarkIcon by default. Size of checkbox is
 * configurable via the height prop and width is always equivalent to height.
 * Size is meant to be standardized so changing this prop is meant as an escape
 * hatch and should not be abused.
 */

var Checkbox = function Checkbox(_ref) {
  var label = _ref.label,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 24 : _ref$height,
      checked = _ref.checked,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? "icon" : _ref$fill,
      onChange = _ref.onChange,
      value = _ref.value,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(Label, props, /*#__PURE__*/_react["default"].createElement(Root, {
    fill: fill,
    height: height,
    mr: 1
  }, /*#__PURE__*/_react["default"].createElement("input", {
    checked: checked,
    onChange: onChange,
    type: "checkbox",
    value: value || label
  }), /*#__PURE__*/_react["default"].createElement(_reactMotion.Motion, {
    style: {
      visibility: (0, _reactMotion.spring)(getVisibilityState(checked), {
        damping: 20,
        stiffness: 210
      })
    }
  }, function (interpolatingStyle) {
    return /*#__PURE__*/_react["default"].createElement(Check, {
      style: getIconStyle(interpolatingStyle.visibility)
    });
  })), label);
};

Checkbox.propTypes = propTypes;
var _default = Checkbox;
exports["default"] = _default;